import React from 'react';

import { StyledText } from './Text.styles';
import { TTextProps } from './Text.types';

const Text = ({ children, ...props }: TTextProps) => <StyledText {...props}>{children}</StyledText>;

export default Text;
